export { PathScaler } from './PathScaler'
export { scaleResize, scaleResizeGroup, scaleResizeFontSize, scaleResizePath, scaleResizePoints } from './scaler'

import { Plugin } from '@leafer-ui/draw'

import './resize'

Plugin.add('resize')